module.exports = __webpack_public_path__ + "img/01_abe_13.5e58775e.jpg";